import React from 'react';

interface CareersProps {
  onLaunchPlatform?: () => void;
}

const Careers: React.FC<CareersProps> = ({ onLaunchPlatform }) => {

  return (
    <div className="bg-[#0a0a0e] text-white min-h-screen overflow-hidden">
      {/* Gradient Backgrounds */}
      <div className="fixed inset-0 overflow-hidden z-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-[#24c35b]/5 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-gradient-to-tl from-[#24c35b]/5 via-transparent to-transparent"></div>
        
        {/* Main Green Glows */}
        <div className="absolute top-1/4 -left-[10%] w-[500px] h-[500px] rounded-full bg-[#24c35b]/5 blur-[150px]"></div>
        <div className="absolute bottom-1/4 -right-[10%] w-[600px] h-[600px] rounded-full bg-[#24c35b]/5 blur-[150px]"></div>
      </div>

      {/* Hero Section - Centered with EKKO logo */}
      <section className="relative min-h-screen flex flex-col items-center justify-center px-4 z-10 pt-12">
        <div className="max-w-4xl mx-auto w-full text-center">
          {/* EKKO Logo */}
          <div className="mb-6">
            <div className="relative inline-block">
              <div className="absolute inset-0 bg-[#24c35b]/20 rounded-full blur-[40px]"></div>
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/EkkoLogo3.png" 
                alt="EKKO" 
                className="relative h-24 w-auto mx-auto"
              />
            </div>
          </div>

          <div className="inline-flex items-center bg-[#0d0d12] rounded-full px-3 py-1 mb-4 border border-[#24c35b]/20">
            <div className="w-2 h-2 rounded-full bg-[#24c35b] mr-2"></div>
            <span className="text-sm">Join Our Team</span>
          </div>
            
          <h1 className="text-4xl md:text-6xl font-bold mb-4 leading-tight">
            Work with <span className="text-[#24c35b]">EKKO</span>
          </h1>
            
          <p className="text-lg text-gray-300 mb-6 max-w-2xl mx-auto">
            Join our mission to revolutionize trading on Solana. We're looking for passionate developers, designers, and trading experts to help build the future of DeFi.
          </p>
          
          <div className="flex gap-4 mb-8 justify-center">
            <button 
              onClick={onLaunchPlatform}
              className="bg-[#24c35b] hover:bg-[#1eaa4e] text-black font-medium px-6 py-3 rounded-lg transition-all duration-300 flex items-center"
            >
              View Openings
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
            <button 
              className="border border-gray-700 hover:border-[#24c35b]/50 text-white px-6 py-3 rounded-lg transition-all duration-300"
            >
              Our Culture
            </button>
          </div>
            
          {/* Network Partners */}
          <div className="flex flex-col items-center mt-4">
            <div className="text-sm text-gray-400 mb-4">We're Hiring</div>
            <div className="flex items-center gap-8 opacity-70">
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/jupiter.png" 
                alt="Jupiter" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/Solana.png" 
                alt="Solana" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/raydium.png" 
                alt="Raydium" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/pumpfun.png" 
                alt="Pump.fun" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/pkin.png" 
                alt="PKIN" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
              <img 
                src="https://raw.githubusercontent.com/ekkoplat/logos/refs/heads/main/nvidia.png" 
                alt="NVIDIA" 
                className="h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300"
              />
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Careers; 